import React, { Component, } from 'react';
import { arrayOf, string, object, } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Widget from '../../../../legacy-tv-ui/Widget';
import Table from '../../../../legacy-tv-ui/Table';
import Td from '../../../../legacy-tv-ui/Td';
import Tr from '../../../../legacy-tv-ui/Tr';
import Th from '../../../../legacy-tv-ui/Th';
import { color, } from '../../../../legacy-tv-dls';
// import Tooltip from 'material-ui/Tooltip';
import Footnote from '../../../../components/Footnote';


const RANK_MAP = {
  '2': {
    text: '看好',
    color: color.return.up,
  },
  '1': {
    text: '相對看好',
    color: color.return.up,
  },
  '0': {
    text: '中立',
    color: '#aaa',
  },
  '-1': {
    text: '相對不看好',
    color: color.return.down,
  },
  '-2': {
    text: '不看好',
    color: color.return.down,
  },
};

export class RankingTable extends Component {
  static propTypes = {
    data: arrayOf(object),
    footnote: string.isRequired,
  }
  static defaultProps = {
    data: [],
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Grid
        item
        xs={12}
        md={6}
        style={{
          padding: 20,
        }}
      >
        <Widget
          title="各市場預測 - 評分"
        >
          <Table style={{ width: '100%', }}>
            <thead>
              <Tr>
                <Th>市場</Th>
                <Th>區域</Th>
                <Th>預測評分</Th>
              </Tr>
            </thead>
            <tbody>
              {
                this.props.data.map(datum => (
                  <Tr key={datum.region}>
                    {
                      datum.renderMarket
                        ? <Td rowSpan={`${datum.renderMarket}`} style={{ textAlign: 'center', backgroundColor: '#f9f9f9', }}>
                          {datum.market}
                        </Td>
                        : null
                    }
                    <Td
                      style={{
                        textAlign: 'center',
                        backgroundColor: '#f9f9f9',
                        textDecoration: datum.fullName && 'underline',
                        cursor: datum.fullName && 'help',
                      }}
                      title={`${datum.fullName}`}
                    >
                      {datum.region}
                    </Td>
                    <Td style={{
                      color: RANK_MAP[datum.ranking].color,
                      textAlign: 'center',
                    }}
                    >
                      {RANK_MAP[datum.ranking].text}
                    </Td>
                  </Tr>
                ))
              }
            </tbody>
          </Table>
          {
            this.props.footnote &&
            <Footnote>{this.props.footnote}</Footnote>
          }
        </Widget>
      </Grid>
    );
  }
}

export default RankingTable;



// WEBPACK FOOTER //
// ./src/scenes/Prediction/components/RankingTable/index.js